import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
	getCurrentVenueOfflineQueryKey,
	getCurrentVenueQueryKey,
} from "./use-get-current-venue";
import { CurrentVenueFragment } from "./fragments/current-venue";
import { gqlReq } from "~/libs/gql";
import {
	GetCurrentVenueQuery,
	UpdateCurrentVenueDocument,
	UpdateCurrentVenueMutationVariables,
} from "~/types/__generated/gql/graphql";

void (
	/* GraphQL */ `
		mutation UpdateCurrentVenue($input: UpdateCurrentVenueInput!) {
			updateCurrentVenue(input: $input) {
				...CurrentVenueFragment
			}
		}
		${CurrentVenueFragment}
	`
);

export const getUpdateCurrentVenueMutationKey = () => ["updateCurrentVenue"];

export const useUpdateCurrentVenue = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationKey: getUpdateCurrentVenueMutationKey(),
		mutationFn: async (variables: UpdateCurrentVenueMutationVariables) =>
			gqlReq({
				document: UpdateCurrentVenueDocument,
				variables,
			}),
		onSuccess: (data) => {
			queryClient.setQueryData<GqlResultOf<GetCurrentVenueQuery>>(
				getCurrentVenueQueryKey(),
				data,
			);
			queryClient.setQueryData(getCurrentVenueOfflineQueryKey(), data);
		},
	});
};
